<template>
  <div class="work-processes">
    <div class="work-processes__container">
      <MobileRender />
      <div class="work-processes__items work-items">
        <div class="work-items__top-elements">
          <div class="work-items__text-block text-block">
            <h4 class="text-block__title">
              {{ WORK_PROCESSES.conceptualDesign.title }}
            </h4>
            <span class="text-block__annotation">
              {{ WORK_PROCESSES.conceptualDesign.mainText }}
            </span>
          </div>
          <div class="work-items__text-block text-block">
            <h4 class="text-block__title">
              {{ WORK_PROCESSES.documentation.title }}
            </h4>
            <span class="text-block__annotation">
              {{ WORK_PROCESSES.documentation.mainText }}
            </span>
          </div>
          <div class="work-items__text-block text-block">
            <h4 class="text-block__title">
              {{ WORK_PROCESSES.implementation.title }}
            </h4>
            <span class="text-block__annotation">
              {{ WORK_PROCESSES.implementation.mainText }}
            </span>
          </div>
        </div>
        <div class="work-items__separator" />
        <div class="work-items__bottom-elements">
          <div class="work-items__text-block text-block">
            <h4 class="text-block__title">
              {{ WORK_PROCESSES.discussion.title }}
            </h4>
            <span class="text-block__annotation">
              {{ WORK_PROCESSES.discussion.mainText }}
            </span>
          </div>
          <div class="work-items__text-block text-block">
            <h4 class="text-block__title">
              {{ WORK_PROCESSES.development.title }}
            </h4>
            <span class="text-block__annotation">
              {{ WORK_PROCESSES.development.mainText }}
            </span>
          </div>
          <div class="work-items__text-block text-block">
            <h4 class="text-block__title">
              {{ WORK_PROCESSES.presentation.title }}
            </h4>
            <span class="text-block__annotation">
              {{ WORK_PROCESSES.presentation.mainText }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import MobileRender from './components/MobileRender.vue'

import { WORK_PROCESSES } from './consts'

export default defineComponent({
  name: 'WorkProcesses',
  components: { MobileRender },
  setup() {
    return { WORK_PROCESSES }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
